'use strict';

import React from 'react';
import { PropTypes } from 'react';
import Group from '../organisms/Group';
import SidebarBody from '../organisms/SidebarBody';
import createStoreMixin from '../mixins/createStoreMixin';
import DraftFeedbackStore from '../stores/DraftFeedbackStore';
import DraftActionCreators from '../actions/DraftActionCreators';
import PureRenderMixin from '../mixins/PureRenderMixin';
import UserStore from '../stores/UserStore';
import EmptyState from '../molecules/EmptyState';

var DraftFeedbacks = React.createClass({
  mixins: [createStoreMixin(DraftFeedbackStore, UserStore), PureRenderMixin],

  propTypes: {
    draftUuid: PropTypes.string.isRequired
  },

  getStateFromStores() {
    return {
      messages: DraftFeedbackStore.getDraftFeedbacks(this.props.draftUuid)
    };
  },

  render: function () {
    var { draftUuid } = this.props;

    return (
      <SidebarBody title='Feedback'>
        <Group type='messages'
               items={this.state.messages}
               context='sidebar'
               mode='grid'
               columns={1}
               isExpectingPage={DraftFeedbackStore.isExpectingPage(draftUuid)}
               isLastPage={DraftFeedbackStore.isLastPage(draftUuid)}
               isInvalidated={DraftFeedbackStore.isInvalidated(draftUuid)}
               loadNextPage={this.requestNextPage}>
          <EmptyState label='There is no any feedbacks so far'
                        absoluteCenter />
        </Group>
      </SidebarBody>
    );
  },

  requestNextPage() {
    DraftActionCreators.requestDraftFeedbackPage(this.props.draftUuid);
  }
});

module.exports = DraftFeedbacks;



/** WEBPACK FOOTER **
 ** ./sidebar/DraftFeedbacks.jsx
 **/